import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=3d71b17e&scoped=true&lang=html&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"
import style0 from "./Accordion.vue?vue&type=style&index=0&id=3d71b17e&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d71b17e",
  null
  
)

export default component.exports